import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/hooks/useAuth";
import AdminLayout from "@/pages/AdminLayout";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import LeadsPage from "@/pages/LeadsPage";
import ServicesPage from "@/pages/ServicesPage";
import SeoPagesPage from "@/pages/SeoPagesPage";
import BlogArticlesPage from "@/pages/BlogArticlesPage";
import AvisPage from "@/pages/AvisPage";
import SettingsPage from "@/pages/SettingsPage";
import PublicLayout from "@/components/public/PublicLayout";
import HomePage from "@/pages/public/HomePage";
import ServicesListPage from "@/pages/public/ServicesListPage";
import ServiceDetailPage from "@/pages/public/ServiceDetailPage";
import ContratsEntreprisesPage from "@/pages/public/ContratsEntreprisesPage";
import AvisClientsPage from "@/pages/public/AvisClientsPage";
import AProposPage from "@/pages/public/AProposPage";
import ContactPage from "@/pages/public/ContactPage";
import SeoPage from "@/pages/public/SeoPage";
import BlogListPage from "@/pages/public/BlogListPage";
import BlogArticlePage from "@/pages/public/BlogArticlePage";

import PlanDuSitePage from "@/pages/public/PlanDuSitePage";
import CityHubPage from "@/pages/public/CityHubPage";
import LandingPage from "@/pages/public/LandingPage";
import NotFoundPage from "@/pages/public/NotFoundPage";
import MentionsLegalesPage from "@/pages/public/MentionsLegalesPage";
import ConditionsGeneralesPage from "@/pages/public/ConditionsGeneralesPage";
import PolitiqueConfidentialitePage from "@/pages/public/PolitiqueConfidentialitePage";
import PolitiqueCookiesPage from "@/pages/public/PolitiqueCookiesPage";

function AccentRedirect() {
  useEffect(() => {
    try {
      const decoded = decodeURIComponent(window.location.pathname);
      const normalized = decoded
        .replace(/[èéêë]/g, "e")
        .replace(/[àâä]/g, "a")
        .replace(/[ùûü]/g, "u")
        .replace(/[îï]/g, "i")
        .replace(/ô/g, "o")
        .replace(/ç/g, "c")
        .replace("yverdon-les-bains", "yverdon");
      if (normalized !== decoded) {
        window.location.replace(normalized);
      }
    } catch (err) {
      console.warn("[AccentRedirect] URL normalization failed:", err);
    }
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AccentRedirect />
      <Toaster position="top-right" richColors />
      <Routes>
          <Route path="/admin/login" element={<AuthProvider><LoginPage /></AuthProvider>} />
          <Route path="/admin" element={<AuthProvider><AdminLayout /></AuthProvider>}>
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="seo" element={<SeoPagesPage />} />
            <Route path="blog" element={<BlogArticlesPage />} />
            <Route path="avis" element={<AvisPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="/devis/:slug" element={<LandingPage />} />
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<HomePage />} />
            <Route path="services" element={<ServicesListPage />} />
            <Route path="services/:slug" element={<ServiceDetailPage />} />
            <Route path="contrats-entreprises" element={<ContratsEntreprisesPage />} />
            <Route path="avis-clients" element={<AvisClientsPage />} />
            <Route path="a-propos" element={<AProposPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="blog" element={<BlogListPage />} />
            <Route path="blog/:slug" element={<BlogArticlePage />} />
            <Route path="plan-du-site" element={<PlanDuSitePage />} />
            <Route path="mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="conditions-generales" element={<ConditionsGeneralesPage />} />
            <Route path="politique-de-confidentialite" element={<PolitiqueConfidentialitePage />} />
            <Route path="politique-cookies" element={<PolitiqueCookiesPage />} />
            <Route path="nettoyage-lausanne" element={<CityHubPage />} />
            <Route path="nettoyage-geneve" element={<CityHubPage />} />
            <Route path="nettoyage-yverdon" element={<CityHubPage />} />
            <Route path="nettoyage-montreux" element={<CityHubPage />} />
            <Route path="nettoyage-nyon" element={<CityHubPage />} />
            <Route path="nettoyage-fribourg" element={<CityHubPage />} />
            <Route path="nettoyage-neuchatel" element={<CityHubPage />} />
            <Route path="nettoyage-sion" element={<CityHubPage />} />
            <Route path=":slug" element={<SeoPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
